<template>
  <div>

    <!-- Header Alert -->
    <b-alert
      show
      variant="light"
      class="alert alert-custom alert-white alert-shadow fade show gutter-b"
    >
      <div class="alert-icon">
        <span class="svg-icon svg-icon-lg">
          <inline-svg src="/media/svg/icons/Tools/Compass.svg" />
        </span>
      </div>
      <div class="alert-text">
        <div class="d-flex justify-content-start align-items-center image-container">
          <div style='height: 50px; width: 50px; position: relative'>
            <img
              class="image"
              :src="doctor.photo"
            >
          </div>
          <div>Jadwal Praktek <strong>{{ doctor.name }}</strong></div>
        </div>
      </div>
      <b-button
        squared
        variant="success"
        @click="btnAddOnClick"
        v-b-modal.modal-form
        v-if="manipulateBtn == true"
      >Tambah</b-button>
    </b-alert>

    <!-- Schedule List -->
    <div class="row">
      <div class="col-md-12">
        <Card>
          <template v-slot:body>
            <Table
              :fields="fields"
              :items="items"
              :perPage="perPage"
              :currentPage="currentPage"
              :totalRows="totalRows"
              :hasDoctor="true"
              @pageOnClick="pageOnClick"
              @btnEditOnClick="btnEditOnClick"
              @btnDeleteOnClick="btnDeleteOnClick"
            />
          </template>
        </Card>
      </div>
    </div>

    <!-- Modal Form -->
    <Form
      :form="form"
      :route="route"
      :editTarget="editTarget"
      :hasDoctor="true"
      @formOnSubmit="formOnSubmit"
    />

  </div>
</template>

<script>

import Card from "@/view/content/Card.vue"
import Form from '@/component/schedules/Form.vue'
import Table from '@/component/schedules/Table.vue'
import module from '@/core/modules/CrudModule.js'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  components: {
    Card,
    Form,
    Table
  },

  data() {
    return {
      // Form
      form: {
        doctor_id: '',
        day_name: '',
        start_time: '',
        end_time: '',
        duration: '',
      },
      // Pagination
      perPage: 20,
      currentPage: 1,
      totalRows: 0,
      // Form Route
      route: 'schedules',
      // Table Head
      fields: [
        {
          key: "number",
          label: "#",
          sortable: true,
        },
        {
          key: "day_name",
          label: "Hari",
          sortable: true,
        },
        {
          key: "start_time",
          label: "Jam Mulai",
          sortable: true,
        },
        {
          key: "end_time",
          label: "Jam Selesai",
          sortable: true,
        },
        {
          key: "duration",
          label: "Durasi (Menit)",
          sortable: true,
        },
        { key: "actions", label: "Aksi" },
      ],
      // Table Items
      items: [],
      // Doctor Data
      doctor: {},
      // Other
      editTarget: '',
      // access management
      manipulateBtn: false,
    }
  },

  methods: {

    pageOnClick(page) {
      this.currentPage = page
      this.pagination()
    },

    async pagination() {
      let response = await module.paginate(`schedules/get-by-doctor/${this.$route.params.id}`, `?page=${this.currentPage}&page_size=${this.perPage}`)
      let pagination = response.meta.pagination
      this.items = response.data
      this.totalRows = pagination.total

      let a, b
      b = this.perPage * (this.currentPage - 1) + 1
      for (a = 0; a < response.data.length; a++) {
        response.data[a].number = b + a
      }
      this.items = response.data
    },

    async getDoctorData() {
      this.doctor = await module.get('doctors/' + this.$route.params.id)
      this.form.doctor_id = this.doctor.id
      // If Data Not Found
      if (this.doctor == null) {
        // Redirect To List
        this.$router.push('/doctors/list')
      }
    },

    btnAddOnClick() {
      this.editTarget = ""
    },

    async btnEditOnClick(id) {
      this.editTarget = id.toString()
      this.form = await module.get(`schedules/${id}`)
      this.form['_method'] = 'put'
    },

    async btnDeleteOnClick(id) {
      // Delete Data
      let result = await module.delete(`schedules/${id}`)
      // If Deleted
      if (result) {
        this.pagination()
      }
    },

    formOnSubmit() {      
      this.pagination()
    },

    // access management
    async setActiveMenu() {

      let access_right_user = window.localStorage.getItem("access_right_display")
      let access_right = JSON.parse(access_right_user)

      let a
      for (a = 0; a < access_right.length; a++) {
        

        if (access_right[a] == "4002") {
          this.manipulateBtn = true
        }

      }
    },

  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Dokter", route: "" },
      { title: "Daftar Dokter", route: "/doctor/list" },
      { title: "Jadwal Praktek" },
    ])
    // Get Doctor Data
    this.getDoctorData()
    // Get Table Data
    this.pagination()
    // access management
    this.setActiveMenu()
  },

}

</script>